import { Button } from 'shards-react'
import React from 'react'
import addFont from '../../../../fonts/fonts'
import jsPDF from 'jspdf'
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import styles from '../styles.module.css'
import { useSelector } from 'react-redux';
import logo from '../../../../img/logo.png'
import gukLogo from '../../../../img/guk_logo.png'


const orientation = 'l'
const fileTitle = `Отчет о поступлении выпускников`

export default function Buttons ({ visible, reportParams, data }) {

  const { year, idOrg } = reportParams

  const orgList = useSelector(state => state.reports.orgList.data)

  // const org = orgList.find(org => org.idOrganization == idOrg)

  const getXLSdata = async () => {
    const wb = new ExcelJS.Workbook();
    const usedSheetNames = new Set();

    const uniqueSheetName = (name) => {
      let candidate = name.slice(0, 31);
      if (!usedSheetNames.has(candidate)) { usedSheetNames.add(candidate); return candidate; }
      let i = 2;
      while (true) {
        const suffix = ` (${i})`;
        candidate = name.slice(0, 31 - suffix.length) + suffix;
        if (!usedSheetNames.has(candidate)) { usedSheetNames.add(candidate); return candidate; }
        i++;
      }
    };

    const thinBorder = { style: 'thin', color: { argb: 'FF000000' } };
    const border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };

    // Парсит HTML-таблицу с учётом colspan/rowspan
    // Возвращает grid[row][col] = { value, isHeader } и список merges
    const parseTable = (table) => {
      const trs = Array.from(table.querySelectorAll('tr'));
      const grid = [];
      const merges = [];

      trs.forEach((tr, rowIndex) => {
        if (!grid[rowIndex]) grid[rowIndex] = [];
        const cells = Array.from(tr.querySelectorAll('th, td'));
        let colIndex = 0;

        cells.forEach(cell => {
          while (grid[rowIndex][colIndex]) colIndex++;

          const colspan = parseInt(cell.getAttribute('colspan') || '1');
          const rowspan = parseInt(cell.getAttribute('rowspan') || '1');
          const value = cell.innerText.trim();
          const isHeader = cell.tagName === 'TH';

          for (let r = rowIndex; r < rowIndex + rowspan; r++) {
            if (!grid[r]) grid[r] = [];
            for (let c = colIndex; c < colIndex + colspan; c++) {
              grid[r][c] = { value: r === rowIndex && c === colIndex ? value : null, isHeader };
            }
          }

          if (rowspan > 1 || colspan > 1) {
            merges.push({ r1: rowIndex, c1: colIndex, r2: rowIndex + rowspan - 1, c2: colIndex + colspan - 1 });
          }

          colIndex += colspan;
        });
      });

      return { grid, merges };
    };

    data.forEach((item) => {
      const table = document.getElementById(`graduatesTable_${item[0].idorganization}`);
      const { grid, merges } = parseTable(table);

      const sheetName = uniqueSheetName(
        item[0].orgname.replaceAll('\r\n', ' ').replace(/[\\/?*[\]]/g, '').trim()
      );
      const ws = wb.addWorksheet(sheetName);

      grid.forEach((gridRow, rowIndex) => {
        const row = ws.getRow(rowIndex + 1);
        row.height = gridRow[0]?.isHeader ? 30 : 20;

        gridRow.forEach((cellData, colIndex) => {
          if (cellData === undefined) return;
          const cell = row.getCell(colIndex + 1);
          if (cellData.value !== null) cell.value = cellData.value;
          cell.border = border;
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
          if (cellData.isHeader) {
            cell.font = { bold: true };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
          }
        });
      });

      merges.forEach(({ r1, c1, r2, c2 }) => {
        ws.mergeCells(r1 + 1, c1 + 1, r2 + 1, c2 + 1);
      });

      // Авто-ширина колонок
      ws.columns.forEach(col => {
        let maxLen = 10;
        col.eachCell(cell => {
          const len = cell.value ? String(cell.value).length : 0;
          if (len > maxLen) maxLen = len;
        });
        col.width = Math.min(maxLen, 50);
      });
    });

    const buffer = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileTitle}.xlsx`);
  }

  const getPdfData = async () => {
    
    addFont(jsPDF.API)
    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation: orientation })

    const {width, height} = doc.internal.pageSize
    let lastY = 35

    const getY = (indent, newValue) => {
      let newY = newValue ? newValue + indent : lastY + indent
      if (newY > height - 15) {
        doc.addPage('a4', orientation)
        newY = 10
      }
      lastY = newY
      return newY
    }


    doc.setFont('Montserrat')

    doc.addImage(logo, 'PNG', width/2 - 20, 5, 40, 27.09)
    doc.addImage(gukLogo, 'PNG', 10, 5, 30, 37.35)

    doc.setFontSize('11')

    doc.text('Министерство обороны Российской Федерации', width/2, lastY, 'center')    
    doc.text('Управление военного образования Главного управления кадров', width/2, getY(12), 'center')
    doc.text('Министерства обороны Российской Федерации', width/2, getY(7), 'center')
    doc.setFontSize('12').setFont(undefined, 'bold')

    data.forEach((item, index) => {
      if (index > 0) {
        doc.addPage('a4', orientation)
        lastY = 35
      }

      // const orgNameParts = org ? doc.splitTextToSize(`в ${org.orgName}`, 300).filter(i => !!i) : []
      const orgName = item[0].orgname.replaceAll('\r\n', ' ')
      const orgNameParts = doc.splitTextToSize(orgName, 300).filter(i => !!i)

      if (index > 0) {
        lastY = 10
        doc.text('Список выпускников', width/2, lastY, 'center')
        // doc.text(item[0].orgname.replaceAll('\r\n', ' '), width/2, getY(5), 'center')
        orgNameParts.forEach(part => doc.text(part, width/2, getY(7), 'center'))
        doc.text(`поступающих в высшие военно-учебные заведения в ${year} году`, width/2, getY(5), 'center')
      } else {
        doc.text('Список выпускников', width/2, getY(12), 'center')
        // doc.text(item[0].orgname.replaceAll('\r\n', ' '), width/2, getY(7), 'center')
        orgNameParts.forEach(part => doc.text(part, width/2, getY(7), 'center'))
        doc.text(`поступающих в высшие военно-учебные заведения в ${year} году`, width/2, getY(7), 'center')
      }

      doc.autoTable({
        html: `#graduatesTable_${item[0].idorganization}`,
        styles: { font: 'Montserrat', fontSize: 7 },
        headStyles: {
          halign: 'center',
          valign: 'middle',
          lineWidth: 0.25,
          lineColor: 200,
        },
        bodyStyles: {
          halign: 'center',
          lineWidth: 0.25,
          lineColor: 200,
        },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { halign: 'left', cellWidth: 30 },
          2: { cellWidth: 35 },
          3: { cellWidth: 30 },
          4: { cellWidth: 30 },
          5: { cellWidth: 30 },
          6: { cellWidth: 30 },
          7: { cellWidth: 30 },
        },
  
        startY: index > 0 ? 25 : getY(7),
      })
    })

    return doc
  }

  const toPdf = () => {
    getPdfData().then(doc => doc.save(`${fileTitle}.pdf`))
  }
  
  const toExcel = () => {
    getXLSdata()
  }
  
  if (!visible) return null;

  return (
    <div className={styles.buttonsBlock}>
      <Button theme='success' className={'mb-2'} onClick={toExcel}>
        Скачать .xlsx
      </Button>
      &nbsp;
      <Button theme='danger' className={'mb-2'} onClick={toPdf}>
        Скачать .pdf
      </Button>
    </div>
)
}
